export default "__VITE_ASSET__CfSJHj5y__"